(() => {
  const init = (root) => {
    if (root.dataset.scReady) return;
    root.dataset.scReady = 'true';
    const steps = [...root.querySelectorAll('[data-sc-quiz-step]')];
    const top = root.querySelector('[data-sc-quiz-top]');
    const back = root.querySelector('[data-sc-quiz-back]');
    const progress = root.querySelector('[data-sc-quiz-progress]');
    const bar = root.querySelector('[data-sc-quiz-bar]');
    const result = root.querySelector('[data-sc-quiz-result]');
    const list = root.querySelector('[data-sc-quiz-products]');
    const empty = root.querySelector('[data-sc-quiz-empty]');
    const all = root.querySelector('[data-sc-quiz-all]');
    const max = parseInt(root.dataset.max, 10) || 4;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const answers = [];
    let index = 0;
    let timer;
    let run = 0;

    const focusHeading = (el) => el && el.focus({ preventScroll: false });

    const show = (i, focus) => {
      index = i;
      result.hidden = true;
      top.hidden = false;
      steps.forEach((step, n) => {
        step.hidden = n !== i;
      });
      back.hidden = i === 0;
      progress.textContent = window.scStrings.quizProgress.replace('[current]', i + 1).replace('[total]', steps.length);
      bar.style.width = `${((i + 1) / steps.length) * 100}%`;
      const chosen = answers[i];
      steps[i].querySelectorAll('[data-sc-quiz-answer]').forEach((a) => {
        a.setAttribute('aria-pressed', String(a === chosen));
      });
      if (focus) focusHeading(steps[i].querySelector('.sc-quiz__question'));
    };

    // Matches come from the all-products collection filtered by the chosen tags. When nothing
    // carries every tag, the earliest question's answer is let go first, so the last question
    // (what they are shopping for) holds longest.
    const fetchMatches = async () => {
      const base = root.dataset.url.replace(/\/$/, '');
      const tags = answers.map((a) => (a && a.dataset.tag) || '');
      for (let drop = 0; drop <= tags.length; drop += 1) {
        const kept = tags.slice(drop).filter(Boolean);
        if (drop > 0 && !tags[drop - 1] && drop < tags.length) continue;
        const url = kept.length ? `${base}/${kept.join('+')}` : base;
        const response = await fetch(`${url}?section_id=sc-quiz-results`);
        if (!response.ok) continue;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = [...doc.querySelectorAll('ul[data-count] > li')];
        if (items.length) return { url, items };
      }
      return { url: base, items: [] };
    };

    const finish = async () => {
      const mine = ++run;
      steps.forEach((step) => (step.hidden = true));
      top.hidden = true;
      result.hidden = false;
      list.innerHTML = '';
      list.setAttribute('aria-busy', 'true');
      empty.hidden = true;
      focusHeading(result.querySelector('.sc-quiz__question'));
      let found = { url: root.dataset.url, items: [] };
      try {
        found = await fetchMatches();
      } catch (error) {
        /* network error: fall through to the empty note */
      }
      if (mine !== run) return;
      found.items.slice(0, max).forEach((li) => list.appendChild(document.importNode(li, true)));
      list.setAttribute('aria-busy', 'false');
      list.hidden = found.items.length === 0;
      empty.hidden = found.items.length > 0;
      all.href = found.url;
    };

    root.addEventListener('click', (event) => {
      const answer = event.target.closest('[data-sc-quiz-answer]');
      if (answer) {
        answers[index] = answer;
        steps[index].querySelectorAll('[data-sc-quiz-answer]').forEach((a) => {
          a.setAttribute('aria-pressed', String(a === answer));
        });
        clearTimeout(timer);
        const go = () => (index < steps.length - 1 ? show(index + 1, true) : finish());
        if (reduce) go();
        else timer = setTimeout(go, 220);
        return;
      }
      if (event.target.closest('[data-sc-quiz-back]')) {
        clearTimeout(timer);
        if (index > 0) show(index - 1, true);
        return;
      }
      if (event.target.closest('[data-sc-quiz-restart]')) {
        run += 1;
        answers.length = 0;
        show(0, true);
      }
    });

    // In the theme editor, selecting a question block jumps to its screen.
    document.addEventListener('shopify:block:select', (event) => {
      const n = steps.findIndex((step) => step.contains(event.target));
      if (n > -1) show(n, false);
    });

    if (steps.length) show(0, false);
    root.classList.add('sc-quiz--ready');
  };

  const run = () => document.querySelectorAll('[data-sc-quiz]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
})();
